module.exports = __webpack_public_path__ + "img/91.0ba30e20.jpg";